export default {
      id: "menu_fixe_accueil-usage",
      viewBox: "0 0 23 21.47",
      url: "../dist/images/" + "sprite.svg#menu_fixe_accueil-usage",
      toString: function () {
        return this.url;
      }
    }